import { FieldName } from '../../utils/enums';

export const INTUITIVE_FIELD_ORDER = {
  [FieldName.FIRST_NAME]: 0,
  [FieldName.LAST_NAME]: 1,
  [FieldName.GENDER]: 2,
  [FieldName.DATE_OF_BIRTH]: 3,
  [FieldName.CHART_NUMBER]: 4,
  [FieldName.ZIP_CODE]: 5,
  [FieldName.MI]: 6
};

export const getGenderAtBirthFieldTransformer = genderAtBirthLabel => formField =>
  formField.name === FieldName.GENDER ? { ...formField, label: genderAtBirthLabel } : formField;

export const getDisplayedFormFields = (formFields, { isIntuitiveFlow = false, transformField = null } = {}) => {
  if (!Array.isArray(formFields)) {
    return [];
  }

  if (!isIntuitiveFlow) {
    return formFields;
  }

  const normalizedFields =
    typeof transformField === 'function' ? formFields.map(field => transformField(field)) : [...formFields];

  return [...normalizedFields].sort((fieldA, fieldB) => {
    const fieldAOrder = Number.isInteger(INTUITIVE_FIELD_ORDER[fieldA.name])
      ? INTUITIVE_FIELD_ORDER[fieldA.name]
      : Number.MAX_SAFE_INTEGER;
    const fieldBOrder = Number.isInteger(INTUITIVE_FIELD_ORDER[fieldB.name])
      ? INTUITIVE_FIELD_ORDER[fieldB.name]
      : Number.MAX_SAFE_INTEGER;
    return fieldAOrder - fieldBOrder;
  });
};
